import React from 'react';
import { 
  Box, 
  Dropdown,
  DatePicker
} from 'monday-ui-react-core';

function ReportFilters({ filters, onChange, businesses = [] }) {
  const dateRangeOptions = [
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const businessOptions = (businesses || []).map(business => ({
    value: business.id,
    label: business.name
  }));

  return (
    <Box className="report-filters">
      {businessOptions.length > 0 && (
        <Dropdown
          placeholder="Select Business"
          value={filters.businessId}
          options={businessOptions}
          onChange={(value) => onChange({ ...filters, businessId: value })}
        />
      )}
      
      <Dropdown
        placeholder="Select Date Range"
        value={filters.dateRange}
        options={dateRangeOptions}
        onChange={(value) => onChange({ ...filters, dateRange: value })}
      />
      
      {filters.dateRange === 'custom' && (
        <Box className="custom-date-range">
          <DatePicker
            placeholder="Start Date"
            value={filters.startDate}
            onChange={(date) => onChange({ ...filters, startDate: date })}
          />
          <DatePicker
            placeholder="End Date"
            value={filters.endDate}
            onChange={(date) => onChange({ ...filters, endDate: date })}
          />
        </Box>
      )}
    </Box>
  );
}

export default ReportFilters; 